/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type contract_terminations_InitiateTerminationRequest = {
    auto_approve?: boolean;
    contract_group_id?: string;
    contract_id?: string;
    reason?: string;
    requested_termination_date?: string;
    source: contract_terminations_InitiateTerminationRequest.source;
};
export namespace contract_terminations_InitiateTerminationRequest {
    export enum source {
        WEB_ADMIN = 'web_admin',
        EMAIL = 'email',
        PARENT_APP = 'parent_app',
    }
}

